import { render, staticRenderFns } from "./Experta.vue?vue&type=template&id=13ffb76e&scoped=true"
import script from "./Experta.vue?vue&type=script&lang=js"
export * from "./Experta.vue?vue&type=script&lang=js"
import style0 from "./Experta.vue?vue&type=style&index=0&id=13ffb76e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ffb76e",
  null
  
)

export default component.exports